module.exports = __webpack_public_path__ + "img/default.a17c0235.png";